var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 16a1 1 0 0 1 1 1 5.013 5.013 0 0 1-4.784 4.995L17 22H7c-2.76 0-5-2.245-5-5a1 1 0 0 1 2 0 3.006 3.006 0 0 0 2.824 2.995L7 20h10a3.013 3.013 0 0 0 2.995-2.825L20 17a1 1 0 0 1 1-1zM12 2a1 1 0 0 1 .993.883L13 3v11.578l3.294-3.286a1 1 0 0 1 1.32-.082l.094.084a1 1 0 0 1 .082 1.32l-.084.094-4.921 4.912a.998.998 0 0 1-.721.378l-.03.001L12 18h-.032c-.026 0-.051-.002-.076-.005L12 18a.983.983 0 0 1-.624-.21l-.094-.084-5-5.01A1 1 0 0 1 7.604 11.2l.094.084L11 14.594V3a1 1 0 0 1 1-1z",
    fill: "#111827",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsDownload);
export default __webpack_public_path__ + "static/media/icons-download.b3f5cd9bbba127a85755d5d713c0b910.svg";
export { ForwardRef as ReactComponent };